import { createContext, useContext, useEffect, useState } from "react";
import { getUserRolePermissions } from "../services/authService";
import { useAuth } from "./AuthContext";

const PermissionContext = createContext(null);

export const PermissionProvider = ({ children }) => {

  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const userRoles = user?.roles;
  const permissionEnum = {
    CREATE: 'create',
    READ: 'read',
    UPDATE: 'update',
    DELETE: 'delete'
  }

  useEffect(() => {
    const loadPermissions = async () => {
      try {
        setLoading(true);
        const res = await getUserRolePermissions();
        const userRolePermission = res?.filter((accessEle) => userRoles?.includes(accessEle.role))
        setPermissions(userRolePermission);
      } catch (error) {
        console.error("Failed to load permissions", error);
        setPermissions(null);
      } finally {
        setLoading(false);
      }
    };

    // Only load permissions if userRoles is defined
    if (userRoles && userRoles.length > 0) {
      loadPermissions();
    } else {
      setLoading(false);
    }
  }, [user,userRoles]);

  return (
    <PermissionContext.Provider value={{ permissions, loading, permissionEnum }}>
      {children}
    </PermissionContext.Provider>
  );
};


export const usePermission = () => {
  const context = useContext(PermissionContext);

  if (!context) {
    throw new Error(
      "usePermission must be used within a PermissionProvider"
    );
  }

  return context;
};